import { Box, Grid } from '@mui/material';
import React from 'react';
import Navbar from './Navbar';

const Header = () => {
  return (
    <Grid item>
      <Box sx={{ position: 'fixed', width: '100%', zIndex: 10, backgroundColor: '#fff' }}>
        <Navbar />
      </Box>
    </Grid>
  );
};

export default Header;
